import React from 'react';

import { CheckmarkAnimation } from '@eika/checkmark-animation';

import { Format } from '@/domain/app';

import { Card } from '@generated-types';
import useText from '@hooks/use-text';

interface PermissionHasBeenSignedProps {
    card: Card;
}

const PermissionHasBeenSigned = ({ card }: PermissionHasBeenSignedProps) => {
    const {
        googleWalletConfirmAddPermissionToGooglePayPermissionConfirmed,
        googleWalletConfirmAddPermissionToGooglePayRedirectToEnrollment,
    } = useText();

    return (
        <div className="google-pay__signing__permission-is-given">
            <CheckmarkAnimation />
            <h3 className="h3">{`${googleWalletConfirmAddPermissionToGooglePayPermissionConfirmed} ${Format.cardNumber(card.number)}.`}</h3>
            <p>{googleWalletConfirmAddPermissionToGooglePayRedirectToEnrollment}</p>
        </div>
    );
};

export default PermissionHasBeenSigned;
